import PropTypes from 'prop-types';
import React from 'react';
import { Box, Flex, StarRating } from 'roo-ui/components';
import TripAdvisorRating from 'components/TripAdvisorRating';

const PropertyRatings = ({ starRating, starRatingType, customerRating }) => (
  <Flex flexDirection="row" alignItems="center" my={2}>
    <Box mr={2}>
      <StarRating rating={starRating} ratingType={starRatingType} size={12} />
    </Box>
    {customerRating?.source === 'trip_advisor' && (
      <Box>
        <TripAdvisorRating rating={customerRating} small />
      </Box>
    )}
  </Flex>
);

PropertyRatings.propTypes = {
  customerRating: PropTypes.object,
  starRating: PropTypes.number.isRequired,
  starRatingType: PropTypes.string.isRequired,
};

PropertyRatings.defaultProps = {
  customerRating: {},
};

export default PropertyRatings;
